<template>
  <div class="red-packet-rain">
    <div class="main-title">使用帮助/互动游戏/荭包雨</div>
    <h1 class="page-title">荭包雨</h1>
    <h4 class="content-text">
      （1）可以先在后台设置下荭包雨的相关信息，不设置就是统一默认，直接进入互动游戏即可。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain1_17682904165111a43a1.webp"
      alt="后台设置荭包雨游戏模式"
      class="example-image"
    />
    <h4 class="content-text">
      （2）荭包雨都需要提前充值到荭包口袋，扫码进入互动后点进手机右下角的福袋。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain2_17682904165114a613f.webp"
      alt="扫码进入荭包雨游戏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain3_1768290416512a0bb38.webp"
      alt="选择荭包雨游戏开始"
      class="mobile-image"
    />
    <h4 class="content-text">
      （3）荭包雨有两种形式，玩法都是差不多的，摇荭包是通过摇动手机获取荭包，点荭包是通过点击手机端掉落荭包获取荭包。大屏端选择荭包雨进入，输入荭包金额和荭包个数，确定后，等待用户扫码进入，开始游戏。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain4_1768290416512191380.webp"
      alt="输入荭包雨游戏的金额和个数"
      class="example-image"
    />
    <h4 class="content-text center">
      （摇荭包）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain5_1768290416512e41165.webp"
      alt="点击荭包雨游戏开始"
      class="example-image"
    />
    <h4 class="content-text center">
      （点荭包）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain6_1768290416512dfda0e.webp"
      alt="酒吧荭包雨游戏进行中"
      class="mobile-image"
    />
    <h4 class="content-text center">
      （摇荭包手机端）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-redPacketRain7_17682904165116415f4.webp"
      alt="酒吧荭包雨游戏进行获得奖励"
      class="mobile-image"
    />
    <h4 class="content-text center">
      （点荭包手机端）
    </h4>
  </div>
</template>

<script>
export default {
  name: 'RedPacketRain',
};
</script>

<style lang="less" scoped>
.red-packet-rain {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}

.center {
  text-align: center;
  margin-top: 0;
}
</style>
